import 'vuetify/styles'; // Ensure you are using css-loader
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import i18n from '@/locale';
import locales from '@/locale/vuetify';
import { light, dark } from './vuetifyThemes.js';

const opts = {
	components,
	directives,
	theme: {
		defaultTheme: 'light',
		themes: {
			light,
			dark,
		},
	},
	lang: {
		locales,
		current: 'en',
		t: (key, ...params) => i18n.t(key, params),
	},
};

export default createVuetify(opts);
